export default {
	CM_NORMAL: {
		name: 'CLOUDMESSAGE_NORMAL'
	},
	CM_PROMOTION: {
		name: 'CLOUDMESSAGE_PROMOTION'
	}
};
